const URL_MAP = {
  BASE_URL: '',
  CREATE: 'create',
  EDIT: 'edit',
  LIST: 'list',
  FAVORITE: 'favorite',
  TEMPLATES: 'templates',
  START: 'start',
  PASSED: 'passed',
  STATISTIC: 'statistic',
  SENT: 'sent',

  USERS: 'users',
  PROFILE: 'profile',
  HTML_LAYOUTS: 'html-layouts',
  FEED: 'feed',
  EXAMPLE: 'example',
  LOGIN: 'login',
  REGISTRATION: 'registration',
  CANDIDATE: 'candidate',
  EMPLOYERS: 'employers',
  AGENCY: 'agency',
  SERVICE: 'service',
  CALL: 'call',
  RESTORE_PASSWORD: 'restore-password',
  ABOUT_COMPANY: 'about-company',
  PLANS: 'plans',
  YOU_CANDIDATE: 'candidate',
  YOU_EMPLOYER: 'employer',
  YOU_AGENCY: 'staff-agency',
  ROLE_DETAILS: 'details',
  NEWS: 'news',
  CONTACTS: 'contacts',
  REQUISITES: 'requisites',
  TECHNICAL_SUPPORT: 'technical-support',
  SOFTWARE_REQUIREMENTS: 'software-requirements',
  PROCESSING_POLICY: 'processing-policy',
  LEGAL_DOCUMENTS: 'legal-documents',
  PRIVACY_POLICY: 'privacy-policy',
  USER_AGREEMENT: 'user-agreement',
  ERROR_404: '404',
  DOCUMENTS: 'documents',
  PERSONAL_DATA_PROCESSING: 'personal-data-processing',
  PERSONAL_DATA_PROCESSING_STATIC: '/documents/processing-policy/personal-data-processing',
  SERVICE_TERMS: 'service-terms',
  TERMS_OF_USE: 'terms-of-use',
  SAFE_MNJ: 'safe-mnj',
  HELP: 'help',
  PROFILE_SETTINGS: 'profile-settings',
  VERIFY: 'verify',
  VIDEO_SESSIONS: 'videosessions',
  VIDEO_POLL_ITEM: 'video-poll-item',
  MY_VIDEO_POLL: 'my-video-poll',
  CREATE_POLL: 'create-poll',
  VIDEO_POLL_LIST: 'list',
  SENT_POLLS: 'sent-polls',
  VIDEO_POLL_FAVORITE: 'favorite',
  CONTACTS_LIST_PAGE: 'contacts-list',
  ADMIN_PANEL: 'admin-panel',
  ADD_NEW_USER: 'add-new-user',
  USER_EDIT: 'user-edit',
  PORTFOLIO: 'portfolio',
  TARIFFS: 'tariffs',
  INDIVIDUAL_TARIFFS: 'individual-tariffs',
  INSTRUCTIONS: 'instructions',
  ADMIN_PANEL_TARIFFS: 'tariffs',
  ADMIN_PANEL_INSTRUCTIONS: 'instructions',
  ADMIN_PANEL_PAYMENTS: 'payments',
  PAYMENTS: 'payments',
  ADMIN_PANEL_LANDING_SECTION_SETTINGS: 'landing-settings',
  LANDING_SECTION_SETTINGS: 'landing-settings',
  VIDEO_RECORD: 'videosessions',
  FEEDBACK: 'feedback',
  AUTH_FB: 'fb-auth',
  AUTH_VK: 'vk-auth',
  AUTH_OK: 'ok-auth',
  AUTH_MAIL_RU: 'mail-auth',
  ACCOUNT_LINK_FB: 'fb-link-account',
  ACCOUNT_LINK_VK: 'vk-link-account',
  ACCOUNT_LINK_OK: 'ok-link-account',
  ACCOUNT_LINK_MAIL_RU: 'mail-link-account',
  CART: 'cart',
  CARD_PAYMENT: 'card-payment',
  HOW_IT_WORK: 'how-it-work',
  REQUISITES_PAYMENT: 'requisites-payment',
  FOUNDERS: 'founders',
  RECORD_REQUEST: 'record-request',
  CONTROL_PANEL: 'control-panel',
  VIDEO_POLLS: 'video-polls',
  VIDEO_CONVERSATIONS: 'video-conversations',
  VIDEO_INTERVIEWS: 'video-interviews',
  VIDEO_VACANCIES: 'video-vacancies',
  VIDEO_MATERIALS: 'video-materials',

  VIDEO_SESSION: 'video-session',
  MY_VIDEO_SESSION: 'my-video-session',
  VIDEO_RESUME: 'video-resume',
  MY_VIDEO_RESUME: 'my-video-resume',
  VIDEO_VACANCY: 'video-vacancy',
  MY_VIDEO_VACANCY: 'my-video-vacancy',
  VIDEO_BUSINESS_CARD: 'video-business-card',
  MY_VIDEO_BUSINESS_CARD: 'my-video-business-card',

  FREE_VIDEOSESSIONS: 'free-videosessions',
  VIDEOINTERVIEW_RECORDING: 'videointerview-recording',
  VIDEORESUME_RECORDING: 'videoresume-recording',
  VIDEOVACANCY_RECORDING: 'videovacancy-recording',
  CANDIDATES_PORTFOLIO: 'candidates-portfolio',
  VIDEOPOOL_RECORDING: 'videopool-recording',
  LINKS: 'links',
  TEXT_RESUME: 'text-resume',
  TEXT_VACANCY: 'text-vacancy',
  VACANCIES_DATA_BASE: 'vacancies-data-base',
  RESUME_DATA_BASE: 'resume-data-base',
  WORK_SEARCHES: 'work-searches',
  CANDIDATE_SEARCHES: 'candidate-searches',
  PERSONAL_PAGE: 'personal-page',
  CANDIDATES_FLOW: 'candidates-flow',
  PASSED_VIDEO_POLL: 'passed-video-poll',

  ONLINE_POLL: 'online-poll',
  ONLINE_POLLS: 'online-polls',
  TARIFF_SERVICE: 'tariff-service',
  VIDEO_POLL_TEMPLATES: 'video-poll-templates',
  TARIFF_ISSUANCE: 'tariff-issuance',
  STANDARD_TARIFF: 'standard-tariff',
  INDIVIDUAL_TARIFF: 'individual-tariff',
};

export default URL_MAP;
